<template lang="pug">
.ride-container(ref="specialRideCard" :class="rideCardClass")
  .privilege-tip(v-if="showPrivilegeTip && isPlayExchangeCoupon")
    img.new-icon(src="https://m.hellobike.com/resource/gallery/43/7cIhET8h_17899291.png")
    span 新特权: 支持券膨胀或券置换
    img.close-icon(@click="()=>{this.showPrivilegeTip = false}" src="https://m.hellobike.com/resource/gallery/43/BPv0kxmF_chahao.png")
  .ride-title
    img.coupon-remind(:src="getHighLightTitleImg()" v-show="showHighLight")
    .free-title-text(v-if="freeRightsVersion()" :style="{'opacity': showHighLight ? 0 : 1}") 月月免费领
      span.free-brown-text 专属优惠券
    span(
      v-else
      :style="{'opacity': showHighLight ? 0 : 1}"
      ) {{(env.isAliMP||env.isAliMPMonitor||env.isAlipayBrowser)?'专属优惠券':'专属优惠券免费领'}}
    .right-arrow(
      v-if="couponGameAB!=='N' && !showHighLight && isPlayExchangeCoupon"
      :style="couponGameAB==='Y' ? amtWidth(iconArr) : ''")
      .right-icons
        img.right-icon(
          v-for="(item,index) in iconArr" :src="item"
          :style="amtDelay(iconArr,index)")
      div(v-if="couponGameAB==='Y'" @click="openExchange") 换券
      div(v-if="couponGameAB==='Z'" @click="openRecord") 变更记录
      img.right-arrow-img(src="https://m.hellobike.com/resource/gallery/61/mC06IKxf03.png")
  .ride-card(ref="rideCar")
    .list(:style="{ 'justify-content': list.length < 4 ? 'center' : '' }")
      CouponOpenedLotteryNew.new-coupon-item(v-for="(item,index) in list"
        :item="item"
        :vipOpen="true"
        @click-btn="firstStatus"
        :couponGameAB="couponGameAB"
        @openExtend="openExtend"
      )
    .list(
      v-if="listBottom.length"
      :style="listBottomStyle"
      )
      CouponOpenedLotteryNew.new-coupon-item(v-for="(item,index) in listBottom"
        :item="item"
        :vipOpen="true"
        @click-btn="firstStatus"
        :couponGameAB="couponGameAB"
        @openExtend="openExtend"
      )
</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  safeGet,
} from '@/utils';
import { env } from '@hb/hbridge';
import { Storage } from '@/utils/storage';
import { applyDynamicKeyframes } from '@/utils/liveAnimation';
import eventBus from '@/const/eventBus.js';
import { debounce } from '@/utils/index';
import CouponOpenedLotteryNew from '@/pages/vip/super/components/coupon-opened-lottery-new.vue';
import { CouponMapper } from '../utils';

export default {
  components: {
    CouponOpenedLotteryNew,
  },
  props: {
    groups: {
      type: Object,
      default: null,
    },
    couponGameAB: {
      type: String,
      default: 'N',
    },
    vipData: {
      type: Object,
      default: () => ({}),
    },
    isLotteryNew: {
      type: Boolean,
      default: false,
    },
    isPlayExchangeCoupon: {
      type: Boolean,
      default: true,
    },
  },
  inject: ['getPropVersion', 'freeRightsVersion'],

  data() {
    return {
      env,
      smallfont: '',
      op: 'opacity: 0.7;', // 已使用3
      showPrivilegeTip: false,
      iconArr: [
        'https://m.hellobike.com/resource/gallery/192/jTkVEAdkJo.png',
        'https://m.hellobike.com/resource/gallery/192/saGSnov_mv.png',
        'https://m.hellobike.com/resource/gallery/192/EM_fU_46pU.png',
      ],
      showHighLight: false,
    };
  },
  computed: {
    rideCardClass() {
      return {
        newcoupon: this.vipData.expandAllPropertyAB === 'Y',
        'highlight-border shine-light': this.showHighLight,
        lottery_v2_new: this.isLotteryNew,
      };
    },
    version() {
      if (this.getPropVersion) {
        return this.getPropVersion();
      }
      return '';
    },
    list() {
      if (this.groups && Array.isArray(this.groups.coupons)) {
        return this.groups.coupons.slice(0, 4).map((item) => ({
          ...item,
          changeRecord: item.changeRecord ? CouponMapper(item.changeRecord) : null,
        }));
      }
      return [];
    },
    listBottom() {
      if (this.groups && Array.isArray(this.groups.coupons)) {
        return this.groups.coupons.slice(4).map((item) => ({
          ...item,
          changeRecord: item.changeRecord ? CouponMapper(item.changeRecord) : null,
        }));
      }
      return [];
    },
    expansiveList() {
      // eslint-disable-next-line array-callback-return
      if (this.groups && Array.isArray(this.groups.coupons)) {
        const tempList = this.groups.coupons.filter((x) =>
          // eslint-disable-next-line no-unused-expressions, implicit-arrow-linebreak
          x.detail.vipExtendProperty);
        if (tempList.length <= 0) {
          return false;
        }
        return tempList[0];
      }
      return [];
    },
    listBottomStyle() {
      if (this.listBottom && this.listBottom.length > 4) {
        return {
          'justify-content': 'flex-start',
          'overflow-x': 'auto',
        };
      }
      return {
        'justify-content': this.listBottom && this.listBottom.length < 4 ? 'center' : '',
      };
    },
  },
  mounted() {
    eventBus.$on('clickLockLottery', () => {
      this.handleShineClick();
    });
    this.showTip();
    applyDynamicKeyframes(this.iconArr, 0.12, false, 'ride-card-slide');
  },
  methods: {
    getGoodsPropDesc() {
      if (this.expansiveList && this.expansiveList.detail
        && this.expansiveList.detail.goodsPropDesc) {
        return this.expansiveList.detail.goodsPropDesc;
      }
      return '';
    },
    showTip: debounce(function showTipFun() {
      if (this.couponGameAB === 'Y' || this.couponGameAB === 'Z') {
        const tipShowFlagStorage = Storage.getItem('tip-show-flag');
        const tipShowFlag = !tipShowFlagStorage && !this.freeRightsVersion();

        if (tipShowFlag) {
          this.showPrivilegeTip = true;

          Storage.setItem('tip-show-flag', true);
          setTimeout(() => {
            this.showPrivilegeTip = false;
          }, 7000);
        }
      }
    }, 800),
    openExchange() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_exchange_coupons',
        categoryId: 'platform',
        businessInfo: {},
      });
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_exchange_coupons_pop',
        contentId: 'platform_exchange_coupons_pop',
        exposureTimes: 1,
        businessInfo: {},
      });
      const list = safeGet(this.groups, 'coupons', []).map((item) => ({
        ...item,
        changeRecord: item.changeRecord ? CouponMapper(item.changeRecord) : null,
      }));
      this.$emit('open-exchange', list);
    },
    firstStatus(val) {
      this.$emit('click-btn', val);
    },
    openExtend(val) {
      this.$emit('openExtend', val);
    },
    openRecord() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_Change_Record',
        categoryId: 'platform',
        businessInfo: {},
      });
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_Change_Record_pop',
        contentId: 'platform_Change_Record_pop',
        exposureTimes: 1,
        businessInfo: {},
      });
      this.$emit('openRecord');
    },
    getList() {
      if (Array.isArray(this.groups.coupons)) {
        return this.groups.coupons.splice(0, 4);
      }
      return [];
    },
    amtWidth(list) {
      if (!list || !list.length) return '';
      return `width:${list.length * 0.14 + 0.47}rem`;
    },
    amtDelay(list, index) {
      if (!list || !list.length) return '';
      return `animationDelay:${-(6 / list.length) * index}s`;
    },
    handleShineClick() {
      if (this.showHighLight) return;
      this.showPrivilegeTip = false;
      this.showHighLight = true;
      setTimeout(() => {
        this.showHighLight = false;
      }, 3000);
      this.scrollToRef('specialRideCard');
    },
    scrollToRef(refName) {
      if (!refName) return;
      const ele = this.$refs[refName];
      if (ele) {
        setTimeout(() => {
          const rect = ele.getBoundingClientRect();
          const scrollTop = document.documentElement.scrollTop
            || window.pageYOffset
            || document.body.scrollTop;
          const top = rect.top + scrollTop;
          const viewportHeight = window.innerHeight;
          // 取绝对值，券模块在上面下面都能兼容
          const scrollDistance = Math.abs(top - viewportHeight * 0.5);
          try {
            if (scrollDistance < 0) return;
            window.scrollTo({
              top: scrollDistance,
              behavior: 'smooth',
            });
          } catch {
            //
          }
        }, 0);
      }
    },
    getHighLightTitleImg() {
      return this.version.includes('ebike')
        ? 'https://m.hellobike.com/resource/gallery/43/2oQe0tTk_782919.png'
        : 'https://m.hellobike.com/resource/gallery/43/7gF-X6xa_1891289.png';
    },
  },
};
</script>
<style lang="less" scoped>
@import '../style.less';

.ride-container {
  width: 3.51rem;
  margin: 0.1rem;
  background: #fff;
  padding: 0.13rem 0 0.12rem 0.12rem;
  border-radius: 0.16rem;
  position: relative;

  &.shine-light {
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      z-index: 2;
      position: absolute;
      display: inline-block;
      left: 0;
      top: 0;
      width: 1rem;
      height: 100%;
      opacity: 0.9;
      transform: skewX(150deg);
      background: linear-gradient(90deg, transparent, #fff 30%, transparent);
      animation: move-light 1.1s infinite;
    }
  }

  @keyframes move-light {
    100% {
      left: 125%;
    }
  }

  &.highlight-border {
    animation: blink-border 1.5s infinite;
    border: 0.015rem solid #fa4614;
    border-radius: 0.16rem;
  }

  @keyframes blink-border {
    0%,
    100% {
      border-color: rgb(250, 70, 20);
    }

    50% {
      border-color: rgba(250, 70, 20, 30%);
    }
  }

  .privilege-tip {
    position: absolute;
    left: 0.15rem;
    top: -0.15rem;
    background-image: url(https://m.hellobike.com/resource/gallery/43/c8H1h4W4Al.png);
    width: 2.08rem;
    height: 0.31rem;
    background-size: 100%;
    display: flex;
    // align-items: center;
    padding: 0.07rem 0 0 0.1rem;
    z-index: 1;
    white-space: nowrap;

    .new-icon {
      width: 0.28rem;
      height: 0.11rem;
      margin-right: 0.04rem;
    }

    span {
      margin-right: 0.06rem;
      height: 0.12rem;
      color: #fff;
      font-family: "PingFang SC", sans-serif;
      font-size: 0.11rem;
      line-height: 0.12rem;
    }

    .close-icon {
      margin-top: 0.02rem;
      width: 0.08rem;
      height: 0.08rem;
    }
  }

  .ride-title {
    position: relative;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.16rem;
    font-weight: 500;
    line-height: 0.22rem;
    display: flex;
    justify-content: space-between;

    .coupon-remind {
      margin-top: 0.02rem;
      height: 0.15rem;
      object-fit: contain;
      position: absolute;
      left: 0;
      top: 0;
    }

    .right-arrow {
      margin-right: 0.11rem;
      padding: 0 0.03rem 0 0.08rem;
      width: auto;
      height: 0.21rem;
      background:
        linear-gradient(
          90deg,
          rgba(255, 220, 189, 0.13) 0%,
          rgba(250, 134, 33, 0.13) 100%
        );
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 500;
      text-align: center;
      color: #fa4614;
      line-height: 0.21rem;
      border-radius: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .right-icons {
        position: relative;
        height: 0.14rem;

        .right-icon {
          animation: ride-card-slide 6s infinite;
          position: absolute;
          top: 0;
          right: 0.03rem;
          width: 0.14rem;
          height: 0.14rem;
        }
      }

      img.right-arrow-img {
        width: 0.12rem;
        height: 0.12rem;
      }
    }
  }

  .ride-card {
    margin-top: 0.1rem;
    height: auto;
    position: relative;
    overflow: hidden;

    .list {
      display: flex;
      overflow-x: hidden;
      justify-content: flex-start;

      .new-coupon-item {
        margin-right: 0.05rem;
      }

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }

      &:not(:last-child) {
        margin-bottom: 0.08rem;
      }

      &:last-child {
        padding-right: 0.06rem;
      }
    }

    &.flex {
      display: flex;
      justify-content: space-between;
    }

    .new-list-top {
      display: flex;
      justify-content: start;
    }

    .list-bottom-center {
      margin-right: 0.12rem;
    }

    .list-bottom-scroll {
      height: 1rem;
      margin-top: 0.08rem;
      margin-bottom: -0.1rem;
      justify-content: flex-start;

      &.scroll {
        overflow-x: auto;
        display: flex;
        justify-content: start;

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    // .card-item {
    //   width: 0.77rem;
    //   height: 0.92rem;
    //   background-image: url(https://m.hellobike.com/resource/helloyun/22871/KsSC1FO4W6.png);
    //   background-size: 100% 100%;

    //   .bussiness {
    //     padding-top: 0.02rem;
    //     font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    //     font-size: 0.12rem;
    //     font-weight: 400;
    //     line-height: 0.12rem;
    //     text-align: center;
    //     color: #7d3b2a;
    //   }

    //   .price {
    //     margin-top: 0.02rem;
    //     display: flex;
    //     justify-content: center;

    //     .num {
    //       font-family: "DIN Alternate Bold", sans-serif;
    //       font-size: 0.26rem;
    //       font-weight: 700;
    //       line-height: 0.28rem;
    //       color: #fa4614;
    //     }

    //     .yuan {
    //       font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    //       font-size: 0.11rem;
    //       font-weight: 500;
    //       margin-top: 0.1rem;
    //       text-align: center;
    //       color: #fa4614;
    //     }
    //   }

    //   .card-word-block {
    //     font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    //     font-size: 0.12rem;
    //     font-weight: 400;
    //     line-height: 0.17rem;
    //     color: #7d3b2a;
    //     text-align: center;
    //     overflow: hidden;
    //     width: 100%;
    //     opacity: 0.7;
    //   }

    //   .card-status {
    //     margin: 0 auto;
    //     margin-top: 0.07rem;
    //     width: 0.54rem;
    //     font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    //     font-size: 0.12rem;
    //     font-weight: 500;
    //     height: 0.18rem;
    //     text-align: center;
    //     color: #7d3b2a;
    //   }
    // }

    .card-item {
      margin-bottom: 0.1rem;
    }
  }

  .ride-word {
    margin-top: 0.06rem;
    margin-left: 0.05rem;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.11rem;
    font-weight: 400;
    line-height: 0.16rem;
    color: #879099;

    .gc {
      color: #7d3b2a;
    }
  }
}

.free-rights-version {
  .ride-container {
    width: 3.59rem;
    padding: 0.14rem 0 0.12rem 0.11rem;
    margin: 0.08rem;
    background: #fff;

    .ride-title {
      .free-title-text {
        padding-left: 0.03rem;
      }
    }

    .ride-card {
      .list {
        &:not(:last-child) {
          margin-bottom: 0.06rem;
        }

        .new-coupon-item {
          margin-right: 0.05rem;
        }
      }
    }
  }
}
</style>
